module.exports = __webpack_public_path__ + "static/media/w4s.e76513d7.svg";